import { AUTO_KIT_TYPE, isTeamColorFill, KitElement, TEAM_COLOR_SOURCE, TeamColorFill } from 'shared/kit';

/**
 * Значения по умолчанию при переключении объекта на цвет команды: первая команда, комплект по
 * правилу `auto`, основной цвет футболки.
 */
export const DEFAULT_TEAM_COLOR_FILL: TeamColorFill = {
  source: TEAM_COLOR_SOURCE,
  teamIndex: 0,
  kitType: AUTO_KIT_TYPE,
  element: KitElement.SHIRT,
  colorIndex: 0,
  mode: 'fill',
};

/** Заливка цветом команды из `object.data`. Старые доски поля не имеют — им `undefined`. */
export function readTeamColorFill(data: unknown): TeamColorFill | undefined {
  const fill = (data as { fill?: unknown } | undefined)?.fill;
  return isTeamColorFill(fill) ? fill : undefined;
}

/**
 * Новый `object.data` с заданной заливкой. Без `fill` ключ удаляется — «свой цвет» это
 * отсутствие записи, а не `source: 'own'`: страж `isTeamColorFill` тогда возвращает false
 * и реплейсер объект не трогает. Остальные поля `data` сохраняются.
 */
export function applyFillSource(data: unknown, fill?: TeamColorFill): Record<string, unknown> {
  const next = { ...(data as Record<string, unknown> | undefined) };
  delete next.fill;
  return fill ? { ...next, fill } : next;
}
